
// Import from the proper sources
import { type ToastActionElement, ToastProps } from "@/components/ui/toast";
import { useState, useEffect, createContext, useContext } from "react";
import { toast as sonnerToast } from "sonner";

// Define types for useToast
type ToasterToast = ToastProps & {
  id: string;
  title?: React.ReactNode;
  description?: React.ReactNode;
  action?: ToastActionElement;
};

const TOAST_LIMIT = 5;
const TOAST_REMOVE_DELAY = 1000;

type ToastContextType = {
  toasts: ToasterToast[];
  addToast: (toast: ToasterToast) => void;
  removeToast: (toastId: string) => void;
  updateToast: (toast: ToasterToast) => void;
};

const ToastContext = createContext<ToastContextType>({
  toasts: [],
  addToast: () => {},
  removeToast: () => {},
  updateToast: () => {},
});

export function useToast() {
  const context = useContext(ToastContext);

  if (context) return context;

  const toasts: ToasterToast[] = [];
  
  return {
    toasts,
    addToast: () => {},
    removeToast: () => {},
    updateToast: () => {},
  };
}

// Export Sonner toast function for direct usage
export const toast = sonnerToast;
